/**
 * Strips HTML tags from a string, leaving only visible text content.
 * Used by form-validation refinements to count visible character length
 * (TextEditor / FormTextEditor inputs may include `<p>`, `<br>`, etc. wrappers).
 */
export const stripHtmlTags = (html: string): string => html.replace(/<[^>]*>/g, "");
